<div class="d-sm-block d-md-none">
    <div class="recipe-list-item">
        <div class="row">
            <div class="col-4" style="height: 170px;">
                <img class="img-fluid" style="height: 150px" [attr.src]="imageURL | async" alt="Image" *ngIf="data?.images?.icon">
                <div class="recipe-image" *ngIf="!data?.images?.icon">
                    <div class="rotate">
                        Recipe Image
                    </div>
                </div>
            </div>
            <div class="col-8" [ngClass]="{'recipe-hidden': data.visible == false}">
                <h5>{{ data.recipeTitle }}</h5>
                <div class="recipe-desc gradient" style="height: 150px; overflow: hidden;">
                    <div>{{ data.recipeDesc }}</div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="d-none d-sm-none d-md-block">
    <div class="m-3">
        <div class="card card-width">
            <img class="class-img-top" style="height: 150px" [attr.src]="imageURL | async" [attr.alt]="data.recipeTitle" *ngIf="data?.images?.icon">
            <div class="class-img-top" style="height: 150px" *ngIf="!data?.images?.icon">
                <div class="recipe-image">
                    <div class="rotate">
                        Recipe Image
                    </div>
                </div>
            </div>
            <div class="card-body panel-height" style="position:relative">
                <h5 class="card-title">{{ data.recipeTitle }}</h5>
                <p class="card-text">{{ data.recipeDesc }}</p>
                <div *ngIf="!data.visible" style="position: absolute; bottom: 10px; right:10px; color: grey;">
                    <fa-icon [icon]="faLockAlt" size="lg"></fa-icon>
                </div>
            </div>
        </div>
    </div>
</div>